// app/javascript/controllers/go_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "alias", "emailFeedback", "aliasFeedback", "emailDisplay", "password", "passwordConfirmation", "passwordFeedback"]

  connect() {
    this.passwordFeedback = this.passwordFeedbackTarget
  }

  validateEmail() {
    const emailValue = this.emailTarget.value.trim()
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const domain = emailValue.split("@").pop()
    const popularDomains = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com"]
    const includedDomains = ["ibm.com", "yourpartnerdomain.com"]

    if (emailValue === '' || emailRegex.test(emailValue)) {
      if (!popularDomains.includes(domain) && !includedDomains.includes(domain)) {
        fetch(`/check_existing_domain_user_count?domain=${encodeURIComponent(domain)}`)
          .then(res => res.json())
          .then(data => {
            this.emailFeedbackTarget.textContent = data.user_count > 0 ?
              'This domain is restricted to one account. Please contact 313.cash support.' : ''
            this.emailFeedbackTarget.style.color = data.user_count > 0 ? 'red' : ''
          })
      } else {
        this.emailFeedbackTarget.textContent = ''
      }
    } else {
      this.emailFeedbackTarget.textContent = 'Please enter a valid email address.'
      this.emailFeedbackTarget.style.color = 'red'
    }
  }

  validateAlias() {
    const aliasValue = this.aliasTarget.value.trim()
    const aliasRegex = /^[a-zA-Z0-9]*$/

    if (!aliasRegex.test(aliasValue)) {
      this.aliasFeedbackTarget.textContent = 'Alias can only contain letters and numbers.'
      this.aliasFeedbackTarget.style.color = 'red'
      this.aliasTarget.value = aliasValue.replace(/[^a-zA-Z0-9]/g, '')
      return
    }

    if (aliasValue.length > 0) {
      this.aliasFeedbackTarget.textContent = 'Checking availability...'
      this.aliasFeedbackTarget.style.color = 'orange'
      this.emailDisplayTarget.textContent = `${aliasValue}@313.cash`

      clearTimeout(this.aliasDebounce)
      this.aliasDebounce = setTimeout(() => this.checkAliasUniqueness(aliasValue), 300)
    } else {
      this.aliasFeedbackTarget.textContent = ''
      this.emailDisplayTarget.textContent = ''
    }
  }

  checkAliasUniqueness(alias) {
    fetch(`/check_alias_uniqueness?alias=${encodeURIComponent(alias)}`)
      .then(res => res.json())
      .then(data => {
        this.aliasFeedbackTarget.textContent = data.is_unique ? 'Alias is available!' : 'Alias is already taken.'
        this.aliasFeedbackTarget.style.color = data.is_unique ? 'green' : 'red'
      })
      .catch(() => {
        this.aliasFeedbackTarget.textContent = 'Error checking alias. Try again later.'
        this.aliasFeedbackTarget.style.color = 'red'
      })
  }

  checkPasswordMatch() {
    const password = this.passwordTarget.value
    const confirmation = this.passwordConfirmationTarget.value

    if (confirmation === '') {
      this.passwordFeedback.textContent = ''
    } else if (password !== confirmation) {
      this.passwordFeedback.textContent = 'Passwords do not match.'
      this.passwordFeedback.style.color = 'red'
    } else {
      this.passwordFeedback.textContent = 'Passwords match!'
      this.passwordFeedback.style.color = 'green'
    }
  }
}
